export const NonBreakingSpace = ({ size = 1 }) => <>{" ".repeat(size).replace(/ /g, "\u00A0")}</>;

export default NonBreakingSpace;
